if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Skip the line component
        this.skipTheLineComponent = document.querySelector(
          ".skip-line-component"
        );

        // Pre add to cart message
        this.initPreAddToCartMessagePopupElements();

        if (this.skipTheLineComponent) {
          this.skipTheLineCheckbox = this.skipTheLineComponent.querySelector(
            ".skip-line-checkbox"
          );
          this.skipTheLineHiddenInput = this.skipTheLineComponent.querySelector(
            ".skip-line-hidden-input"
          );
          this.skipTheLineComponent.addEventListener(
            "click",
            this.skipTheLineHandler.bind(this)
          );
        }
      }

      initPreAddToCartMessagePopupElements() {
        this.preAddToCartMessagePopup = document.querySelector(
          "#pre-add-to-cart-message-popup"
        );
        if (!this.preAddToCartMessagePopup) return;
        this.preAddToCartContinue = this.preAddToCartMessagePopup.querySelector(
          "#pre-add-to-cart-continue"
        );

        this.preAddToCartCancel = this.preAddToCartMessagePopup.querySelector(
          "#pre-add-to-cart-cancel"
        );
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        if (this.checkIfSkipLineIsSelected() === "true") {
          this.addProductWithPriorityProcessing();
          return;
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const hasPreAddToCartMessage =
          this.checkIfHasPreAddToCartMessage(formData);

        if (hasPreAddToCartMessage) {
          const response = await this.showPreAddToCartMessagePopup();
          if (!response) {
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            return;
          }
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      async addProductWithPriorityProcessing() {
        try {
          this.skipTheLineComponent.style.display = "none";

          const formData = new FormData(this.form);
          const formDataObj = Object.fromEntries(formData);
          const cartData = {
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
            items: [
              {
                id: formDataObj.id,
                quantity: formDataObj.quantity,
              },
              {
                id: this.skipTheLineHiddenInput.value,
                quantity: 1,
              },
            ],
          };

          const request = await fetch(
            window.Shopify.routes.root + `cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(cartData),
            }
          );
          const { sections, items } = await request.json();

          const parsedResponse = {
            id: items.map((item) => item.id),
            sections,
          };

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "engraving-form",
            productVariantId: parsedResponse.id,
            cartData: parsedResponse,
          });

          this.cart.renderContents(parsedResponse);
        } catch (error) {
          console.log(error);
        } finally {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      skipTheLineHandler(evt) {
        const element = evt.target.closest(".skip-line-component");
        if (!element);
        const { skipLineCheckboxIsChecked } = this.skipTheLineCheckbox.dataset;
        const isChecked = skipLineCheckboxIsChecked === "true";
        this.skipTheLineCheckbox.dataset.skipLineCheckboxIsChecked = isChecked
          ? "false"
          : "true";
      }

      checkIfSkipLineIsSelected() {
        if (!this.skipTheLineCheckbox) return false;
        return this.skipTheLineCheckbox.dataset.skipLineCheckboxIsChecked;
      }

      checkIfHasPreAddToCartMessage(formData) {
        const formDataObject = Object.fromEntries(formData);
        return formDataObject.hasOwnProperty("has-pre-add-to-cart-message");
      }

      showPreAddToCartMessagePopup() {
        return new Promise((resolve) => {
          this.preAddToCartMessagePopup.dataset.showPreAddToCartMessagePopup = true;

          const continueHandler = () => {
            cleanup();
            resolve(true);
          };

          const cancelHandler = () => {
            cleanup();
            resolve(false);
          };

          const cleanup = () => {
            this.preAddToCartContinue.removeEventListener(
              "click",
              continueHandler
            );
            this.preAddToCartCancel.removeEventListener("click", cancelHandler);
            this.preAddToCartMessagePopup.dataset.showPreAddToCartMessagePopup = false;
          };

          this.preAddToCartContinue.addEventListener("click", continueHandler);
          this.preAddToCartCancel.addEventListener("click", cancelHandler);
        });
      }
    }
  );
}
